export const CLIENT_TYPE = Object.freeze({
  Ios: 1,
  Android: 2,
  PcWeb: 3,
  Msite: 4,
})
